import { useEffect, useState } from 'react';
import styles from './ConnectInstagramModal.module.css';
import api from '../../../../../api'
import { copyToClipboard } from '../../../../../util';

const ConnectInstagramModal = ({setAuthModalPage, account, marginTop}) => {
      const [code, setCode] = useState('- - - - - -');
      const [time, setTime] = useState(0)
      const [username, setUsername] = useState(account.instagramUsername);

      const callGetCodeAPI = async () => {
		try {
			const response = await api.get('/user/instagram/get_code', {
                        params: {
                              type: "connect",
			      }
                  });

                  const connectCode = response.data.code;
                  const expireAt = response.data.expireAt;
			
                  if(connectCode){
                        setCode(connectCode);
                        setTime(expireAt);
                  }
		} catch (error) {
			console.error('There was an error registering the user!', error);
		}
	};

      const handleConnectButtonClick = async () => {
            if(account.hotpleId==null){
                  alert('인스타그램 계정 연결을 위해 먼저 HOTPLE에 로그인해주세요!');
                  setAuthModalPage(1);
                  return;
            }
            try {
                await copyToClipboard(code);
        
                alert('코드가 클립보드에 복사되었어요!\n핫플 계정 팔로우 후, 복사된 코드를 DM으로 보내주세요😊');

                window.open(`https://instagram.com/hotple_kr`, '_blank');
            } catch (error) {
                console.error('Error handling connect button click:', error);
            }
        };

      useEffect(()=>{
            callGetCodeAPI();
            setUsername(account.instagramUsername);
      },[]);

      useEffect(()=>{
            if(username!=account.instagramUsername)
                  setAuthModalPage(0);
      },[account.instagramUsername]);

      useEffect(() => {
            if (time > 0) {
              const timer = setInterval(() => {
                setTime((prevTime) => {
                  if (prevTime <= 1) {
                    clearInterval(timer);
                    setCode('- - - - - -');
                    callGetCodeAPI();
                    return 0;
                  }
                  return prevTime - 1;
                });
              }, 1000);
        
              return () => clearInterval(timer);
            }
      }, [time]);

      return (
            <div className={styles.container} style={{maxHeight: `calc(100dvh - ${marginTop + 24}px)`, marginTop: `${marginTop}px`}}>
                  <div className={styles.header}>
                        <div className={styles.contents}>
                        <b className={styles.title}>인스타그램 계정 연결</b>
                              <div className={styles.innerContents}>
                                    <div className={styles.description}>
                                          <p className={styles.hotpleDm}>
                                                <b className={styles.hotple}>1. HOTPLE 공식 인스타 팔로우</b>
                                                <span className={styles.span}> 한 뒤,</span>
                                          </p>
                                          <p className={styles.a}>
                                                <b className={styles.a1}>2. DM으로 인증 코드</b>
                                                <span className={styles.span1}> 만 보내면 끝!</span>
                                          </p>
                                    </div>
                                    <video 
                                          className={styles.description1} 
                                          src="https://hotple.s3.ap-northeast-2.amazonaws.com/usage/instagram_connect.mp4" 
                                          autoPlay 
                                          loop 
                                          muted 
                                          playsInline
                                    />
                                    <div className={styles.codeFrame}>
                                          <div className={styles.text1}>{`${Math.floor(time / 60).toString().padStart(2, '0')}:${(time % 60).toString().padStart(2, '0')}`}</div>
                                          <div className={styles.codeText}>{code}</div>
                                    </div>
                                    <div className={styles.dmButton} onClick={() => handleConnectButtonClick()}>
                                          <div className={styles.text}>인증코드 DM 보내러가기</div>
                                          <div className={styles.text1}>@hotple_kr</div>
                                    </div>
                              </div>
                        </div>
                  </div>
            </div>
      );
};

export default ConnectInstagramModal;